import React from 'react';
import SEO from '../components/SEO';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiVideo, FiFileText, FiZap } = FiIcons;

export default function Consulting() {
  return (
    <>
      <SEO 
        title="1:1 Social Media Consulting | Otso Co" 
        description="Need a better social media strategy? Our 1:1 consulting helps pet business owners DIY their social media with professional guidance." 
        path="/services/consulting" 
      />
      
      <section className="bg-brand-primaryDark text-brand-white py-24 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-extrabold mb-6 leading-tight">
            1:1 <span className="text-brand-blush">Consulting</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
            You want to do the work, you just want to make sure it's working. Get a custom roadmap for your pet business social media.
          </p>
        </div>
      </section>

      <section className="py-24 px-4 bg-brand-white">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start mb-20">
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-brand-primaryDark">Stop Guessing, Start Growing.</h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                Consulting is perfect for the owner who enjoys creating content but feels like they're shouting into a void. I help you sharpen your message, optimize your profile, and build a strategy that actually leads to bookings.
              </p>
              
              {/* Updated Testimonial Block */}
              <div className="bg-brand-mauve/10 p-8 rounded-2xl border-l-4 border-brand-mauve">
                <h4 className="text-brand-primaryDark font-bold text-lg mb-3 leading-tight">
                  "Strongly recommend Perry if you are looking for solutions without the fluff"
                </h4>
                <p className="text-gray-700 italic mb-4 leading-relaxed">
                  "Perry walked me through a fix for something I'd been struggling with. She also provided some insight and a solution that had never crossed my mind."
                </p>
                <p className="text-brand-primaryDark font-bold text-sm uppercase tracking-wider">— Mike H.</p>
              </div>
            </div>
            
            <div className="bg-brand-primaryDark text-brand-white p-10 rounded-3xl shadow-2xl">
              <h3 className="text-2xl font-bold mb-2 text-brand-blush">$50 / Hour</h3>
              <p className="text-gray-400 mb-8">Pay-as-you-go strategy support</p>
              <ul className="space-y-4 mb-10">
                {[
                  'Social account audit',
                  '60-minute strategy call',
                  'Custom action plan PDF',
                  'Recording of our session',
                  '1 week of email support follow-up'
                ].map((item, i) => (
                  <li key={i} className="flex items-start">
                    <SafeIcon icon={FiCheck} className="text-brand-blush mr-3 mt-1" />
                    <span className="text-lg">{item}</span>
                  </li>
                ))}
              </ul>
              <a href="https://tidycal.com/digital-by-perry/consulting" target="_blank" rel="noopener noreferrer" className="block text-center bg-brand-mediumPurple hover:bg-brand-mauve text-brand-white py-4 rounded-xl font-bold text-lg transition-colors">
                Book a Session
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="text-center p-8">
              <div className="bg-brand-blush w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 text-brand-primaryDark">
                <SafeIcon icon={FiVideo} className="text-2xl" />
              </div>
              <h4 className="text-xl font-bold mb-3">Live Video Call</h4>
              <p className="text-gray-600">We hop on Google Meet to walk through your accounts and strategy together.</p>
            </div>
            <div className="text-center p-8">
              <div className="bg-brand-blush w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 text-brand-primaryDark">
                <SafeIcon icon={FiFileText} className="text-2xl" />
              </div>
              <h4 className="text-xl font-bold mb-3">Custom Audit</h4>
              <p className="text-gray-600">I review your current presence and tell you exactly what's holding you back.</p>
            </div>
            <div className="text-center p-8">
              <div className="bg-brand-blush w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 text-brand-primaryDark">
                <SafeIcon icon={FiZap} className="text-2xl" />
              </div>
              <h4 className="text-xl font-bold mb-3">Quick Wins</h4>
              <p className="text-gray-600">Get immediate changes you can make today to improve your visibility.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}